import ElakayImage from '../../components/images/ElakayImage';
import React, { useEffect, useMemo, useRef, useState } from "react";
import { toImageUrl } from "../../config";
import imageEmptyelakay from "../Layout/imgs/imageEmptyelakay.jpeg";
import "./showImagesLoading.css";

const LoadingImage =(props)=>{
    const {
        imageSrc,
        alt,
        className="card-img-top",
        width = 300,
        height,
        style0 = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          },
        // No default here on purpose -- see the ".eli-img sizing" comment
        // below. A caller that really needs a one-off inline override (e.g.
        // swiperProdView.js's imageStyle) can still pass its own `style`.
        style
    } = props

    const [loaded, setLoaded] = useState(false);
    const imageRef = useRef(null);

    useEffect(() => {
        // A cached image can finish before React receives its load event.
        // Never reset a successful load from a later passive effect.
        if (imageRef.current?.complete && imageRef.current.naturalWidth > 0) {
            setLoaded(true);
        }
    }, []);

      return (
    <div className="eli-wrap">
      {!loaded && (
        <span className={`${className} eli-placeholder`} aria-hidden="true" style={{ ...style0, backgroundColor: '#f1f3f5' }} />
      )}

      <ElakayImage
      ref={imageRef}
      preset={props.preset || (width >= 900 ? "product-detail" : width >= 600 ? "product-medium" : width <= 160 ? "product-thumb" : "product-card")}
      fallback={imageEmptyelakay}
      className={`${className} eli-img${loaded ? ' eli-img--loaded' : ''}`}
        src={imageSrc}
        width={height !== undefined ? width : undefined}
        height={height}
        alt={alt}
        loading={props.priority ? "eager" : "lazy"}
        fetchPriority={props.priority ? "high" : undefined}
        decoding="async"
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        style={style}
      />
    </div>
  );
};

const ShowimagesLoading = (props) => {
    const imageSrc = useMemo(() => toImageUrl(props.src), [props.src]);
    const sourceKey = typeof imageSrc === "string" ? imageSrc
        : imageSrc?.original || imageSrc?.urlImg || imageSrc?.url || imageSrc?.src || imageSrc?.displayUrl || "";
    // Each source owns its loading state, including during pagination.
    return <LoadingImage key={`${sourceKey}|${props.preset || ""}|${props.width || 300}`} {...props} imageSrc={imageSrc} />;
};

export default React.memo(ShowimagesLoading)
